import styled from 'styled-components'
import { colors } from "../../branding";

export const StyledCookieNotification = styled.aside`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.green};
  width: calc(100% - 80px);
  padding: 20px;
  margin: 20px;
  z-index: 2000;
  position: fixed;
  bottom: 0;
  color: ${colors.light};
  border: 2px solid ${colors.pale};
  
  a {
    color: ${colors.light};
    text-decoration: none;
    
    :hover {
      text-decoration: underline;
    }
  }
  
  button {
    background-color: ${colors.light};
    color: ${colors.blueDark};
    padding: 10px;
    border-radius: 5px;
    margin: 0 10px;
    border: 1px solid ${colors.blueDark};
    
    :hover {
      color: ${colors.green};
      border-color: ${colors.green};
    }
  }

  @media (max-width: 520px) {
    flex-direction: column;
    
    button {
      margin-top: 10px;
    }
  }
`
